import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["toggle"]
  static targets = ["sections", "buttonText"]
  static values = {
    expandText: { type: String, default: "Expand All" },
    collapseText: { type: String, default: "Collapse All" }
  }

  connect() {
    this.collapsed = false
  }

  toggleOutletConnected() {
    this._syncState()
  }

  toggleAll() {
    this.collapsed = !this.collapsed
    this._toggling = true

    this.toggleOutlets.forEach((toggle) => {
      if (this.collapsed) {
        toggle.collapse()
      } else {
        toggle.expand()
      }
    })

    this._toggling = false
    this._updateButtonText()
  }

  syncState() {
    if (this._toggling) return
    this._syncState()
  }

  _syncState() {
    if (this.toggleOutlets.length === 0) return

    const allCollapsed = this.toggleOutlets.every((toggle) => !toggle.isExpanded())
    this.collapsed = allCollapsed
    this._updateButtonText()
  }

  _updateButtonText() {
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = this.collapsed ? this.expandTextValue : this.collapseTextValue
    }
  }
}